export default __webpack_public_path__ + "static/media/25120413.0a598500.jpg";